var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3776 2.35847H5.58729C3.09992 2.35847 1.07617 4.38181 1.07617 6.86958V21.4287C1.07617 23.9109 3.0911 25.931 5.57127 25.9398V32.5466L15.0659 25.9398H29.3776C31.8649 25.9398 33.8887 23.9161 33.8887 21.4287V6.86958C33.8887 4.38181 31.8649 2.35847 29.3776 2.35847ZM31.9661 21.4287C31.9661 22.8559 30.8049 24.0172 29.3776 24.0172H14.4627L7.49388 28.8666V24.0172H5.58729C4.15995 24.0172 2.99878 22.8559 2.99878 21.4287V6.86958C2.99878 5.44205 4.15995 4.28107 5.58729 4.28107H29.3776C30.8049 4.28107 31.9661 5.44205 31.9661 6.86958V21.4287Z",
    fill: "#C7C7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85938 9.15188H25.1077V11.0745H9.85938V9.15188Z",
    fill: "#C7C7C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85938 13.2534H25.1077V15.176H9.85938V13.2534Z",
    fill: "#C7C7C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85938 17.355H25.1077V19.2776H9.85938V17.355Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.80987f88c1eb918dde74f5c84dca70e2.svg";
export { ForwardRef as ReactComponent };